import React from "react"
import bgImage from "../../../assets/Images/landingPage/loginBg.png"
import { Button } from "../../../components/Buttons"
import { useNavigate } from "react-router-dom"
const Submit = () => {
  const navigation = useNavigate()
  return (
    <div className="w-[1080px] h-[720px] bg-gradient-to-b from-[#9BD7D0] from-0%  to-[#FFFFFF] to-50% rounded-[24px] overflow-hidden">
      <div
        style={{
          backgroundImage: `url(${bgImage})`,
          backgroundPosition: "top",
          backgroundRepeat: "no-repeat",
          objectFit: "contain",
        }}
        className="bg-[length:400px_400px] flex justify-center items-end w-[100%] h-[100%]  "
      >
        <div className="flex flex-col text-center items-center mb-[118px]">
          <p className="font-filson-soft font-[700] text-[32px] leading-[40px] ">
            Sit tight while we review <br/> your documents!
          </p>
          <p className="font-Apparat font-[500] text-[18px] leading-[28px] text-[#424952D9]">
            We promise to have your approval ready before you know it.
          </p>
          <Button title="Continue to Dashboard" className="mt-[18px]" onClick={()=>navigation('/dashboard')}/>
        </div>
      </div>
    </div>
  )
}

export default Submit
